import fetch from "../utils/fetch";
const backendApi = process.env.REACT_APP_BACKEND_API_URL
// 数据类
export function getDataList(data) {
  return fetch({
    url: "/models/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 获取流程列表
export function getFlowList(data) {
  return fetch({
    url: "/ticket/flow/",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 流程操作
export function flowAction(data) {
  return fetch({
    url: "/ticket/flow_action/",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 删除标签
export function deleteAction({id}) {
  return fetch({
    url: "/backendApi/ticket/" +  id + "/",
    method: "DELETE",
    data: {},
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 导出
export function exportFile(data) {
  return fetch({
    url: "/flow_export/export_ticket_info/",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
    responseType: "blob",
  });
}

// 分类标签
export function getLabelList(data) {
  return fetch({
    url: "/backendApi/ticket/get_lable_options/",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}